import { render, staticRenderFns } from "./ShortsFilter.vue?vue&type=template&id=cf605c9a&scoped=true"
import script from "./ShortsFilter.vue?vue&type=script&lang=js"
export * from "./ShortsFilter.vue?vue&type=script&lang=js"
import style0 from "./ShortsFilter.vue?vue&type=style&index=0&id=cf605c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf605c9a",
  null
  
)

export default component.exports